import React from 'react';
import { NewTripRequest } from '../../types';

interface StepProps {
  formData: NewTripRequest;
  setFormData: React.Dispatch<React.SetStateAction<NewTripRequest>>;
}

const StepNotes: React.FC<StepProps> = ({ formData, setFormData }) => {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      
      {/* Additional Notes */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">Anything else we should know?</h3>
        <p className="text-sm text-gray-500">
            Tell us about special occasions, dietary restrictions, accessibility needs, or any other specific expectations for your trip.
        </p>
        
        <textarea
            value={formData.additionalNotes || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, additionalNotes: e.target.value }))}
            rows={6}
            className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 py-3 px-4 bg-gray-50 text-gray-900"
            placeholder="e.g. It's our honeymoon! We love local food but have a nut allergy. Prefer hidden gems over tourist traps."
        />
      </div>

      <div className="bg-primary-50 rounded-xl p-6 border border-primary-100 mt-4">
        <h4 className="font-semibold text-primary-900 mb-2">Trip Summary</h4>
        <ul className="space-y-2 text-sm text-primary-800">
            <li className="flex gap-2">
                <span className="font-bold min-w-[100px]">Destination:</span>
                <span>{formData.destination}</span>
            </li>
            <li className="flex gap-2">
                <span className="font-bold min-w-[100px]">Dates:</span>
                <span>{formData.startDate} to {formData.endDate}</span>
            </li>
            <li className="flex gap-2">
                <span className="font-bold min-w-[100px]">Travelers:</span>
                <span>{formData.travelers.adults} Adults, {formData.travelers.children} Children</span>
            </li>
        </ul>
      </div>

    </div>
  );
};

export default StepNotes;

